import React from "react";
import { RenderHtml } from "./render-html";

type Props = {
  values: {
    price?: number;
    compareAtPrice?: number;
    membersPrice?: number;
  };
};

export function Price({ values }: Props) {
  const html = `
    <x-price>
      <script type="application/json" name="values">
        ${JSON.stringify(values)}
      </script>
    </x-price>
  `;

  return <RenderHtml html={html} />;
}
